import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { ScreenService } from './services/screen.service';
import { MetaDescriptionService } from './services/meta-description.service';
import { WhatsappUpComponent } from './whatsapp-us/whatsapp-us.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { CookiesAcceptedService } from './services/cookies-accepted.service';
import { GoogleReviewsService } from './services/google-reviews.service';
import { ModalService } from './services/modal.service';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        FontAwesomeModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        WhatsappUpComponent
    ],
    declarations: [
        WhatsappUpComponent
    ],
})
export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule,
            providers: [
                ScreenService,
                MetaDescriptionService,
                GoogleAnalyticsService,
                CookiesAcceptedService,
                GoogleReviewsService,
                ModalService
            ]
        };
    }
}
